import axios from 'axios';
import { API_BASE_URL } from '../config.js';
import { registerParameters } from './RegisterServices.js';

const setCookie = (key, value, expirationInDays) => {
    const now = new Date();
    now.setTime(now.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + now.toUTCString();
    document.cookie = key + "=" + encodeURIComponent(JSON.stringify(value)) + ";" + expires + ";path=/";

    console.log("guardo cookie", key)
};

const getCookie = (key) => {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
            return JSON.parse(cookie.substring(name.length, cookie.length));
        }
    }
    return null;
};

const AuthServices = async (email) => {
    try {
        const response = await axios.get(`${API_BASE_URL}login/`, {
            params: { email: email.toLowerCase() },
            headers: { 'Content-Type': 'application/json' }
        });

        if (response.status === 200) {
            console.log("Response data:", response.data); // Verifica si la respuesta es correcta

            // Guardar la sesión en cookies
            console.log("Guardando sesión...");
            setCookie('userSession', {
                token: response.data['access'],
                name: response.data['name'],
                country: response.data['country'],
                city: response.data['city'],
                email: response.data['email'],
                last_name: response.data['last_name'],
                id_user: response.data['id_user'],
                id_event: response.data['eventInscribed']
            }, 1);

            // Obtener parámetros de la URL
            const urlParams = new URLSearchParams(window.location.search);
            const utmSource = urlParams.get('utm_source');
            const chatLive = urlParams.get('chat');

            console.log(urlParams);

            // Redirige a /chatLive si chat es "yes"
            if (chatLive === 'yes') { // Compara con el string 'yes'
                sessionStorage.setItem('is_chat', true);
                console.log(sessionStorage.getItem('is_chat')); // Verificar si se guarda
            } else if (utmSource === 'qr-code') {
                // Si el parámetro utm_source es 'qr-code'
                sessionStorage.setItem('is_qr', true);
            }

            return response.data;
        }
    } catch (error) {
        console.log('Error:', error.response ? error.response.data : error);
        throw new Error(error.response ? error.response.data.non_field_errors : 'Error en la autenticación');
    }
};

export const AuthParameters = async (email, formdata) => {
    try {
        // Verifica si ya existe una sesión válida antes de hacer la solicitud
        const session = getCookie('userSession');
        if (session) {
            return session; // Devuelve la sesión si aún es válida
        }

        // Si no hay sesión válida, realiza la solicitud
        const response = await axios.get(`${API_BASE_URL}login/`, {
            params: {
                email: email
            },
            headers: {
                'Content-Type': 'application/json', // Tipo de contenido de la solicitud
            }
        });

        if (response.status === 200) {
            // Guardar la sesión en cookies
            setCookie('userSession', {
                token: response.data['access'],
                name: response.data['name'],
                country: response.data['country'],
                city: response.data['city'],
                email: response.data['email'],
                last_name: response.data['last_name'],
                id_user: response.data['id_user'],
                id_event: response.data['eventInscribed']
            }, 1);

            return response.data;
        } else {
            await registerParameters(formdata); // Registro si no existe sesión
        }
    } catch (error) {
        throw error; // Propaga el error para que pueda ser manejado por el llamado
    }
}

export default AuthServices;
